import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { DateService } from '../services/date.service';
import { ActionsService } from '../services/actions.service';
import { MatSelectionList } from '@angular/material/list';
import * as globalUrls from '../services/globalVariables';
@Component({
  selector: 'app-activiter',
  templateUrl: './activiter.component.html',
  styleUrls: ['./activiter.component.scss'],
})
export class ActiviterComponent implements OnInit {
  constructor(
    public actionsService: ActionsService,
    public generalService: GeneralService,
    public dateService: DateService,
    public route: ActivatedRoute
  ) {}
  periode;
  moisTab = this.dateService.monthsTab;
  listeClient = [];
  listeClientFiltred;
  anneeTab;
  listeCollaborateur;
  listeCollaborateurFiltred = [];
  listeAction = [];
  listeActionFiltered;
  mois;
  showMonth = false;
  annee;
  selectionClient = ';';
  selectionCollaborateur = ';';
  selectionAction = ';';
  dataSourceFull = [];
  dataSource = [];
  displayedColumns: Array<string>;
  du: string;
  au: string;
  lastDayOfMonth: number;
  showTable = false;
  ligneVideTab;
  weekday = ['DIM', 'LUN', 'MAR', 'MER', 'JED', 'VEN', 'SAM'];
  listeActionD;
  listeActionDFiltred;
  tbrecherche;
  @ViewChild('liste_Coll', { static: false }) liste_Coll: MatSelectionList;
  @ViewChild('liste_Client', { static: false }) liste_Client: MatSelectionList;
  @ViewChild('liste_Action', { static: false }) liste_Action: MatSelectionList;

  ngOnInit() {
    this.readParamUrl();
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.periode = params['periode'];

      this.intitialise();
    });
  }
  deSelectAllCollaborateurs() {
    this.liste_Coll.deselectAll();
    this.onSelectionColl([]);
  }
  selectAllCollaborateurs() {
    this.liste_Coll.selectAll();
    this.onSelectionColl(this.liste_Coll.selectedOptions.selected);
  }
  deSelectAllClients() {
    this.liste_Client.deselectAll();
    this.onSelectionClient([]);
  }
  selectAllClients() {
    this.liste_Client.selectAll();
    this.onSelectionAction(this.liste_Action.selectedOptions.selected);
  }
  deSelectAllActions() {
    this.liste_Action.deselectAll();
    this.onSelectionAction([]);
  }
  selectAllActions() {
    this.liste_Action.selectAll();
  }
  intitialise() {
    this.setAnnee();
    this.annee = this.anneeTab[5];
    this.mois = new Date().getMonth();
    this.initDuAu();
    this.setListeClient();
    this.setListeCollaborateur();
    this.setListeAction();
    this.showTable = false;
  }
  setListeActionReferent() {
    this.generalService
      .rechercheTable(globalUrls.urlavtActionDLA + this.getListeActionCode())
      .subscribe((actRef) => {
        this.listeActionD = actRef;
      });
  }
  getListeActionCode() {
    var listeCodeAction = '';
    this.listeActionFiltered.forEach((action) => {
      listeCodeAction += action.avtAction_Code + ';';
    });
    return listeCodeAction;
  }
  initDuAu() {
    if (this.periode == 'annuelle') {
      this.showMonth = false;
      this.du = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, 0, 1)
      );
      this.au = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, 11, 31)
      );
    } else {
      this.showMonth = true;
      this.lastDayOfMonth = this.dateService.getLastDayOfMonth(this.mois + 1);
      this.du = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, this.mois, 1)
      );
      this.au = this.dateService.setFormatDateRechercheServer(
        new Date(this.annee, this.mois, this.lastDayOfMonth)
      );
    }
  }
  setListeAction() {
    this.listeAction = [];
    this.initDuAu();
    //************************* */
    this.generalService
      .rechercheTable(
        this.generalService.url +
          'avtActionListDDF2&param=' +
          this.du +
          ',' +
          this.au +
          ',2'
      )
      .subscribe((action) => {
        //avtAction_Type=="0" -> FAF
        this.listeAction = this.generalService.sort(
          action,
          'avtAction_Intitule'
        ); //.filter(act => {return act.avtAction_Type=="0" });
        this.listeActionFiltered = this.generalService.clone(this.listeAction);
        this.setListeActionReferent();
        setTimeout(() => {
          this.selectAllActions();
        }, 100);
      });
  }
  setListeCollaborateur() {
    this.generalService
      .rechercheTable(globalUrls.urlListPerso + '0')
      .subscribe((coll) => {
        this.listeCollaborateur = this.generalService.sort(coll, 'Perso_Nom');
        this.listeCollaborateurFiltred = this.generalService.clone(
          this.listeCollaborateur
        );
        setTimeout(() => {
          this.selectAllCollaborateurs();
        }, 100);
      });
  }
  setListeClient() {
    this.generalService
      .rechercheTable(globalUrls.urlListeClientByType + '1')
      .subscribe((client) => {
        this.listeClient = this.generalService.sort(client, 'Tiers_NomPublic');
        this.listeClientFiltred = this.generalService.clone(this.listeClient);
        setTimeout(() => {
          this.selectAllClients();
        }, 100);
      });
  }
  setAnnee() {
    var date = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    var annee = date.getFullYear();
    this.anneeTab = [
      annee - 5,
      annee - 4,
      annee - 3,
      annee - 2,
      annee - 1,
      annee,
      annee + 1,
    ];
  }
  afficher() {
    //**************** */
    this.initDuAu();
    this.generalService
      .rechercheTable(
        this.generalService.url +
          'avtActionlpc&param=' +
          this.du +
          ',' +
          this.au +
          ',%,%,%'
      )
      .subscribe((data) => {
        this.listeActionD = data;
        if (
          this.listeActionD != undefined &&
          this.listeActionD != null &&
          this.listeActionD.length > 0
        )
          if (this.selectionAction != ';') {
            this.listeActionD = this.listeActionD.filter((actiond) => {
              return (
                this.selectionAction.indexOf(
                  ';' + actiond.avtAction_Code + ';'
                ) >= 0
              );
            });
          } else this.listeActionD = [];
        if (this.selectionClient != ';') {
          this.listeActionD = this.listeActionD.filter((actiond) => {
            return (
              this.selectionClient.indexOf(';' + actiond.Tiers_code + ';') >= 0
            );
          });
        } else this.listeActionD = [];
        if (this.periode == 'annuelle') {
          this.afficherAnnuelle();
        } else {
          this.afficherMonsuelle();
        }
      });
  }
  afficherAnnuelle() {
    this.ligneVideTab = {
      Tiers_NomPublic: {
        icon: 'remove',
        RS: '',
        show: true,
        style: { 'margin-left': '0px' },
        showRow: true,
        code: 'null',
        Tiers_code: '',
        Tiers_codeParent: '',
        niveau: 0,
        actionCode: '',
      },
    };
    this.showTable = false;
    this.initHeaderTableAnnuelle();

    this.initTable();
    this.setDataSource(true);
    this.showTable = true;
  }
  initHeaderTableAnnuelle() {
    this.tbrecherche = [
      {
        TableRD_Champs: 'Tiers_NomPublic',
        TableRD_Des: '',
        TableRD_Largeur: '20%',
      },
    ];
    this.displayedColumns = ['Tiers_NomPublic'];
    var i = 0;
    this.moisTab.forEach((mois) => {
      this.tbrecherche.push({
        TableRD_Champs: i,
        TableRD_Des: mois,
        TableRD_Largeur: '2%',
      });
      this.displayedColumns.push(i.toString());
      this.ligneVideTab[i] = {
        icon: '',
        RS: 0,
        show: false,
        style: { 'text-align': 'center' },
      };
      i++;
    });
  }
  initHeaderTableMensuelle() {
    this.tbrecherche = [
      {
        TableRD_Champs: 'Tiers_NomPublic',
        TableRD_Des: 'Client',
        TableRD_Largeur: '30%',
      },
      { TableRD_Champs: 'totalFAF', TableRD_Des: 'T', TableRD_Largeur: '2%' },
    ];
    this.displayedColumns = ['Tiers_NomPublic', 'totalFAF'];
    for (var i = 1; i < this.lastDayOfMonth + 1; i++) {
      this.displayedColumns.push(i.toString());
      var date = new Date(this.annee, this.mois, i);

      this.tbrecherche.push({
        TableRD_Champs: i.toString(),
        TableRD_Des: i.toString() + ' \n ' + this.weekday[date.getDay()],
        TableRD_Largeur: '2%',
      });
      var isSamediOrDimenche = this.dateService.isSamediOrDimenche(date);
      var style = {
        'background-color': isSamediOrDimenche ? 'rgb(218 218 218)' : '',
        'text-align': 'center',
        height: '30px',
        margin: '0 3px 0 3px',
        color: isSamediOrDimenche ? 'white' : '',
      };
      var RS = date.getDay() == 6 ? 'SA' : date.getDay() == 0 ? 'DI' : 0;
      this.ligneVideTab[i] = { icon: '', RS: RS, show: false, style: style };
    }
  }
  afficherMonsuelle() {
    this.ligneVideTab = {
      Tiers_NomPublic: {
        icon: 'remove',
        RS: '',
        show: true,
        style: { 'margin-left': '0px' },
        showRow: true,
        code: 'null',
        Tiers_code: '',
        Tiers_codeParent: '',
        niveau: 0,
        actionCode: '',
      },
      totalFAF: { RS: 0 },
    };
    this.showTable = false;
    this.initHeaderTableMensuelle();
    this.initTable();
    this.setDataSource(true);
    this.showTable = true;
  }

  initTable() {
    this.dataSourceFull = [];
    if (this.periode == 'annuelle') {
      var ligneAnnee = this.generalService.clone(this.ligneVideTab);
      ligneAnnee.Tiers_NomPublic.RS = this.annee;
      ligneAnnee.Tiers_NomPublic.Tiers_code = this.annee;
      ligneAnnee.Tiers_NomPublic.code = this.annee;
      ligneAnnee.Tiers_NomPublic.Tiers_codeParent = 'null';
      ligneAnnee.Tiers_NomPublic.niveau = 0;
      this.dataSourceFull.push(ligneAnnee);
    }
    this.listeClientFiltred.forEach((client) => {
      var ligneClient = this.generalService.clone(this.ligneVideTab);
      ligneClient.Tiers_NomPublic.RS = client.Tiers_NomPublic;
      ligneClient.Tiers_NomPublic.style = {
        'margin-left': '10px',
        color: 'red',
        'font-weight': 'bold',
        'font-size': '18px',
        'text-transform': 'uppercase',
      };
      ligneClient.Tiers_NomPublic.Tiers_code = client.Tiers_Code;
      ligneClient.Tiers_NomPublic.code =
        this.annee + ';' + client.Tiers_Code + ';';
      ligneClient.Tiers_NomPublic.Tiers_codeParent = this.annee;
      ligneClient.Tiers_NomPublic.niveau = 1;
      var listeAction = this.listeActionFiltered.filter((action) => {
        return action.Tiers_code == client.Tiers_Code;
      });
      if (listeAction.length > 0) {
        this.dataSourceFull.push(ligneClient);
        listeAction.forEach((action) => {
          var ligneAction = this.generalService.clone(this.ligneVideTab);
          ligneAction.Tiers_NomPublic.RS = action.avtAction_Intitule;
          ligneAction.Tiers_NomPublic.Tiers_code = action.avtAction_Code;
          ligneAction.Tiers_NomPublic.code =
            this.annee +
            ';' +
            client.Tiers_Code +
            ';' +
            action.avtAction_Code +
            ';';
          ligneAction.Tiers_NomPublic.Tiers_codeParent =
            this.annee + ';' + client.Tiers_Code + ';';
          ligneAction.Tiers_NomPublic.niveau = 2;
          var listeCollaborateur = this.actionsService.getReferent(
            action.avtAction_Code,
            this.listeActionD,
            this.listeCollaborateurFiltred
          );

          if (listeCollaborateur != null && listeCollaborateur.length > 0) {
            ligneAction.Tiers_NomPublic.style = {
              'margin-left': '32px',
              color: 'blue',
            };
            this.dataSourceFull.push(ligneAction);
            listeCollaborateur.forEach((coll) => {
              var ligneColl = this.generalService.clone(this.ligneVideTab);
              ligneColl.Tiers_NomPublic.style = {
                'margin-left': '85px',
                color: 'green',
              };
              ligneColl.Tiers_NomPublic.show = false;
              ligneColl.Tiers_NomPublic.RS = coll.Perso_Nom;
              ligneColl.Tiers_NomPublic.Tiers_code = coll.Perso_Matricule;
              ligneColl.Tiers_NomPublic.code =
                this.annee +
                ';' +
                client.Tiers_Code +
                ';' +
                action.avtAction_Code +
                ';' +
                client.Tiers_Code +
                ';';
              ligneColl.Tiers_NomPublic.Tiers_codeParent =
                this.annee + client.Tiers_Code + action.avtAction_Code;
              ligneColl.Tiers_NomPublic.niveau = 3;
              ligneColl.Tiers_NomPublic.actionCode = action.avtAction_Code;
              this.dataSourceFull.push(ligneColl);
            });
          } else {
            ligneAction.Tiers_NomPublic.style = {
              'margin-left': '72px',
              color: 'blue',
            };
            this.dataSourceFull.push(ligneAction);
            ligneAction.Tiers_NomPublic.show = false;
          }
        });
      } else {
        ligneClient.Tiers_NomPublic.show = false;
        //this.dataSourceFull.push(ligneClient);
      }
    });
  }
  setDataSource(calculerValeur) {
    if (calculerValeur) this.setValeurDataSource();
    this.dataSource = this.dataSourceFull.filter((ds) => {
      return ds.Tiers_NomPublic.showRow == true;
    });
  }
  setValeurDataSource() {
    this.setNiveau3();
    this.setNiveau(2);
    this.setNiveau(1);
    if (this.periode == 'annuelle') this.setNiveau(0);
    else this.setFAF();
    // this.setNiveau1();
    // this.setNiveau0();
  }
  setFAF() {
    for (var i = 0; i < this.dataSourceFull.length; i++) {
      var result = Object.keys(this.dataSourceFull[i]).map((key) => {
        return this.dataSourceFull[i][key]['RS'];
      });
      for (var j = 0; j < result.length; j++) {
        if (typeof result[j] == 'number') {
          this.dataSourceFull[i].totalFAF.RS += result[j];
          this.dataSourceFull[i].totalFAF.style = {
            'text-align': 'center',
            'font-weight': 'bold',
          };
        }
      }
    }
  }
  setNiveau3() {
    var listeNiveau3 = this.dataSourceFull.filter((ds) => {
      return ds.Tiers_NomPublic.niveau == 3;
    });
    listeNiveau3.forEach((n3) => {
      var listeActionD = this.listeActionD.filter((actionD) => {
        return (
          actionD.avtAction_Code == n3.Tiers_NomPublic.actionCode &&
          actionD.Perso_Matricule == n3.Tiers_NomPublic.Tiers_code
        );
      });
      listeActionD.forEach((ActionD) => {
        if (this.periode == 'annuelle') {
          var day = new Date(ActionD.avtActionD_date).getMonth();
          var nbrHeur = this.actionsService.getNbrHeure([ActionD]);
          if (typeof n3[day].RS == 'number') n3[day].RS += nbrHeur;
        } else {
          var day = new Date(ActionD.avtActionD_date).getDate();
          var nbrHeur = this.actionsService.getNbrHeure([ActionD]);
          if (typeof n3[day].RS == 'number') n3[day].RS += nbrHeur;
        }
      });
      //
    });
  }
  setNiveau(n) {
    var listeNiveau = this.dataSourceFull.filter((ds) => {
      return ds.Tiers_NomPublic.niveau == n;
    });

    listeNiveau.forEach((niveau) => {
      var listeChildren = this.dataSourceFull.filter((ds) => {
        return (
          ds.Tiers_NomPublic.Tiers_codeParent == niveau.Tiers_NomPublic.code
        );
      });
      listeChildren.forEach((lstCh) => {
        if (this.periode == 'annuelle') {
          for (var i = 0; i < 11; i++) {
            if (typeof niveau[i].RS == 'number') niveau[i].RS += lstCh[i].RS;
          }
        } else {
          for (var i = 1; i < this.lastDayOfMonth; i++) {
            if (typeof niveau[i].RS == 'number') niveau[i].RS += lstCh[i].RS;
          }
        }
      });
    });
  }

  onSelectionColl(liste) {
    this.selectionCollaborateur = ';';
    liste.forEach((element) => {
      this.selectionCollaborateur += element.value + ';';
    });
    if (liste.length > 0) {
      this.listeCollaborateurFiltred = this.listeCollaborateur.filter(
        (coll) => {
          return (
            this.selectionCollaborateur.indexOf(
              ';' + coll.Perso_Matricule + ';'
            ) >= 0
          );
        }
      );
    } else {
      this.listeCollaborateurFiltred = []; //this.generalService.clone(this.listeCollaborateur) ;
    }
  }
  onSelectionAction(liste) {
    this.selectionAction = ';';
    liste.forEach((element) => {
      this.selectionAction += element.value + ';';
    });
    if (liste.length > 0) {
      this.listeActionFiltered = this.listeAction.filter((action) => {
        return (
          this.selectionAction.indexOf(';' + action.avtAction_Code + ';') >= 0
        );
      });
    } else {
      this.listeActionFiltered = []; //this.generalService.clone(this.listeAction) ;
    }
  }
  onSelectionClient(liste) {
    this.selectionClient = ';';
    liste.forEach((element) => {
      this.selectionClient += element.value + ';';
    });
    if (liste.length > 0) {
      this.listeClientFiltred = this.listeClient.filter((client) => {
        return this.selectionClient.indexOf(';' + client.Tiers_Code + ';') >= 0;
      });
    } else {
      this.listeClientFiltred = []; // this.generalService.clone(this.listeClient) ;
    }
  }
  toggleRow(row) {
    var show = false;
    if (row.Tiers_NomPublic.icon == 'remove') {
      row.Tiers_NomPublic.icon = 'add';
      show = false;
    } else {
      row.Tiers_NomPublic.icon = 'remove';
      show = true;
    }
    this.dataSourceFull.forEach((ds) => {
      var st1 = ';' + ds.Tiers_NomPublic.code.toString() + ';';
      var str2 = ';' + row.Tiers_NomPublic.Tiers_code + ';';
      if (
        st1.indexOf(str2) >= 0 &&
        row.Tiers_NomPublic.code != ds.Tiers_NomPublic.code
      ) {
        ds.Tiers_NomPublic.showRow = show;
        ds.Tiers_NomPublic.icon = 'remove';
      }
    });
    this.setDataSource(false);
  }
}
